module.exports = __webpack_public_path__ + "img/special-img-1.e5dae191.svg";